import { render, staticRenderFns } from "./InviteCooperation.vue?vue&type=template&id=4db3c714&scoped=true&"
import script from "./InviteCooperation.vue?vue&type=script&lang=js&"
export * from "./InviteCooperation.vue?vue&type=script&lang=js&"
import style0 from "./InviteCooperation.vue?vue&type=style&index=0&id=4db3c714&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db3c714",
  null
  
)

export default component.exports